import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import type { KibCheckboxModelValue } from '@chewy/kib-choices-react'
import * as R from 'ramda'

import ConversationCheckboxFilters from '~/components/dashboard/communications/filters/ConversationCheckboxFilters'
import { TimelineEntryType } from '~/constants/timelineConstants'
import { updateTimelineExcludeSystemMessages } from '~/store/actions/timeline'
import {
  getTimelineExcludeSystemMessages,
  getTimelineFilters,
} from '~/store/reducers/timeline'

const TimelineConversationMessageToggle = () => {
  const dispatch = useDispatch()
  const timelineFilters = useSelector(getTimelineFilters)
  const timelineExcludeSystemMessages = useSelector(
    getTimelineExcludeSystemMessages,
  )
  const { t } = useTranslation(['Common', 'Clients'])
  const showToggle =
    timelineFilters.includes(TimelineEntryType.CONVERSATION) ||
    R.isEmpty(timelineFilters)

  const setSelected = (excludeSystemMessages: boolean) => {
    dispatch(updateTimelineExcludeSystemMessages(excludeSystemMessages))
  }

  const filter = {
    active: !timelineExcludeSystemMessages,
    text: t('Common:SHOW_SYSTEM_MESSAGES'),
    onSelected: (checked: KibCheckboxModelValue) => {
      setSelected(!checked)
    },
  }

  return (
    <>
      {showToggle && (
        <ConversationCheckboxFilters
          filters={[filter]}
          label={t('Clients:TIMELINE.FILTER.COMMUNICATIONS')}
        />
      )}
    </>
  )
}

export default TimelineConversationMessageToggle
